

export const sceneNumbers = {
	initMainMenu: 0,
	introduction: 1,
	topicOne: 2,
	topicTwo: 3,
}